require('./js/core.js');
require('./js/core-desktop.js');
require('./js/core-mobile.js');
require('./js/bigwin.js');
require('./js/widget.js');
require('./js/button.js');
require('./js/meter.js');
require('./js/fontstrip.js');
require('./js/counter.js');
require('./js/roller.js');
require('./js/toggle.js');
require('./js/menu.js');
require('./js/dialog.js');

require('./panel.css');



/** WEBPACK FOOTER **
 ** ./../../../../engine/public-src/spingames/panel/panel.js
 **/